const CART_CONFLICT_PATTERN = /cart conflicted/i;

let mutationTail: Promise<void> = Promise.resolve();

export function enqueueCartMutation<T>(mutation: () => Promise<T>): Promise<T> {
  const next = mutationTail.then(mutation, mutation);
  mutationTail = next.then(
    () => undefined,
    () => undefined,
  );
  return next;
}

export function isCartConflictError(error: unknown): boolean {
  return error instanceof Error && CART_CONFLICT_PATTERN.test(error.message);
}

export async function withCartConflictRetry<T>(
  operation: () => Promise<T>,
  delayMs = 400,
): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    if (!isCartConflictError(error)) throw error;
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    return operation();
  }
}
